// Funções utilitárias para conversão de datas UTC para o fuso de Brasília

export const FUSO_BRASILIA = 'America/Sao_Paulo';

function toValidDate(value) {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatHoraBrasilia(iso) {
  const date = toValidDate(iso);
  if (!date) return '';

  try {
    return new Intl.DateTimeFormat('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: FUSO_BRASILIA,
    }).format(date);
  } catch {
    return '';
  }
}

export function formatDataBrasilia(iso) {
  const date = toValidDate(iso);
  if (!date) return '';

  try {
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: FUSO_BRASILIA,
    }).format(date);
  } catch {
    return '';
  }
}
